"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _argumentContracts = _interopRequireDefault(require("argument-contracts"));

var _coerce = _interopRequireDefault(require("@meltwater/coerce"));

var _defaultShortNumberFormatter = _interopRequireDefault(require("../../label-formatters/default-short-number-formatter"));

var _getValidObject = _interopRequireDefault(require("../../get-valid-object"));

var _legendItemSet = _interopRequireDefault(require("../../legend-item-set"));

var DEFAULT_Y_AXIS_LABEL = undefined;

var DEFAULT_Y_AXIS_LABEL_FORMATTER = function DEFAULT_Y_AXIS_LABEL_FORMATTER(options) {
  return (0, _defaultShortNumberFormatter.default)(options.value);
};

var DEFAULT_BAR_LABEL_FORMATTER = function DEFAULT_BAR_LABEL_FORMATTER(_ref) {
  var key = _ref.key;
  return key;
};

var DEFAULT_ON_BAR_CLICK = undefined;
/**
 * @callback MwChartOneSeriesBarAxisLabelFormatter
 *
 * Custom behavior to format the label for a particular mark on the x-axis.
 *
 * @param {AxisLabelFormatterOptions} options Options provided by the chart
 * @returns {string} Text to show as the x-axis label
 */

/**
 * A class to represent the visualization options for a Bar Chart with a single series of data

 * @param {object} options options object (See below)
 * @param {boolean} [options.animate=true] Dictate whether to animate the chart when rendering
 * @param {function} options.barColorFormatter A function that will be passed a data point from seriesData and should return a valid hex color
 * @param {function} [options.barLabelFormatter] A function that will be passed a data point from seriesData and should return a string for that data points label
 * @param {LegendItemSet} options.legendItemSet The array of unique legend items for display
 * @param {boolean} [options.showSummaryYAxis=false] Tells the chart that it should render in a condensed "summary" mode for the Y axis. The y axis title will be closer to the axis, grid lines will be hidden, and only first and last value labels will be rendered
 * @param {function} [options.onBarClick] A handler the will be passed a BarClickEvent object when a bar is clicked.
 * @param {function} options.tooltipFormatter A function that should return String to display as the tooltip.  It will be passed a MwChartTwoYAxisLineTooltipOptions object when invoked.
 * @param {function} [options.yAxisTitle] The label to be displayed above the yAxis
 * @param {MwChartOneSeriesBarAxisLabelFormatter} [options.yAxisLabelFormatter] A function that should return a string to display labels on the y-axis. Is provided an object with an AxisLabelFormatterOptions object.
 */

var MwChartOneSeriesBarOptions = function MwChartOneSeriesBarOptions(options) {
  (0, _classCallCheck2.default)(this, MwChartOneSeriesBarOptions);
  var safeOptions = (0, _getValidObject.default)(options);

  if (safeOptions.animate === undefined) {
    safeOptions.animate = true;
  } else {
    _argumentContracts.default.assertBoolean(safeOptions.animate, 'options.animate');
  }

  if (typeof safeOptions.barColorFormatter !== 'function') {
    throw new TypeError("options.barColorFormatter must be a function. Provided value: ".concat(safeOptions.barColorFormatter));
  }

  var safeBarLabelFormatter = safeOptions.barLabelFormatter;

  if (safeOptions.barLabelFormatter === undefined) {
    safeBarLabelFormatter = DEFAULT_BAR_LABEL_FORMATTER;
  } else if (typeof safeOptions.barLabelFormatter !== 'function') {
    throw new TypeError("options.barLabelFormatter must be a function. Provided value: ".concat(safeOptions.barLabelFormatter));
  }

  var safeOnBarClick = safeOptions.onBarClick;

  if (safeOptions.onBarClick === undefined) {
    safeOnBarClick = DEFAULT_ON_BAR_CLICK;
  } else if (typeof safeOptions.onBarClick !== 'function') {
    throw new TypeError("options.onBarClick must be a function. Provided value: ".concat(safeOptions.onBarClick));
  }

  if (typeof safeOptions.tooltipFormatter !== 'function') {
    throw new TypeError("options.tooltipFormatter must be a function. Provided value: ".concat(safeOptions.tooltipFormatter));
  }

  var safeYAxisTitle = safeOptions.yAxisTitle;

  if (!safeOptions.yAxisTitle) {
    safeYAxisTitle = DEFAULT_Y_AXIS_LABEL;
  } else if (typeof safeOptions.yAxisTitle !== 'string') {
    throw new TypeError("If provided, options.yAxisTitle must be a string. Provided value: ".concat(safeOptions.yAxisTitle));
  }

  var safeYAxisLabelFormatter = safeOptions.yAxisLabelFormatter;

  if (safeOptions.yAxisLabelFormatter === undefined) {
    safeYAxisLabelFormatter = DEFAULT_Y_AXIS_LABEL_FORMATTER;
  } else if (typeof safeOptions.yAxisLabelFormatter !== 'function') {
    throw new TypeError("options.yAxisLabelFormatter must be a function. Provided value: ".concat(safeOptions.yAxisLabelFormatter));
  }

  var legendItemSet;

  if (safeOptions.legendItemSet !== undefined) {
    legendItemSet = (0, _coerce.default)(safeOptions.legendItemSet, _legendItemSet.default, "options.legendItemSet must be a valid LegendItemSet. Provided value: ".concat(options.legendItemSet));
  }

  this.animate = safeOptions.animate;
  this.barColorFormatter = safeOptions.barColorFormatter;
  this.barLabelFormatter = safeBarLabelFormatter;
  this.legendItemSet = legendItemSet;
  this.showSummaryYAxis = Boolean(safeOptions.showSummaryYAxis);
  this.onBarClick = safeOnBarClick;
  this.tooltipFormatter = safeOptions.tooltipFormatter;
  this.yAxisTitle = safeYAxisTitle;
  this.yAxisLabelFormatter = safeYAxisLabelFormatter;
  Object.freeze(this);
};

exports.default = MwChartOneSeriesBarOptions;